import type { CSSProperties } from 'react'
import { SELECTION_CHECK_BADGE_SIZE_PX, SELECTION_CHECK_GLYPH_SIZE_PX } from '@redevicer/shared'

interface SelectionCheckBadgeProps {
  /** CSS color; falls back to --option-accent / --condition-color on parent. */
  accent?: string
  /** Pin to the right edge of a sell-option-card. */
  anchored?: boolean
  className?: string
}

function CheckGlyph() {
  return (
    <svg
      className="selection-check-badge__glyph"
      viewBox="0 0 12 12"
      width={SELECTION_CHECK_GLYPH_SIZE_PX}
      height={SELECTION_CHECK_GLYPH_SIZE_PX}
      aria-hidden
      focusable="false"
    >
      <path
        d="M2.25 6.1 4.85 8.7 9.75 3.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function SelectionCheckBadge({
  accent,
  anchored = false,
  className = '',
}: SelectionCheckBadgeProps) {
  return (
    <span
      className={`selection-check-badge${anchored ? ' selection-check-badge--card-end' : ''}${className ? ` ${className}` : ''}`}
      style={
        {
          ...(accent ? { '--selection-accent': accent } : {}),
          width: SELECTION_CHECK_BADGE_SIZE_PX,
          height: SELECTION_CHECK_BADGE_SIZE_PX,
        } as CSSProperties
      }
      aria-hidden
    >
      <CheckGlyph />
    </span>
  )
}
